module.exports = __webpack_public_path__ + "static/media/white_strip.b79ba095.svg";